import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    // Lädt bereits gespeicherte Bewerbungen aus dem LocalStorage
    const savedCart = localStorage.getItem("bbs_application_cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem("bbs_application_cart", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (item) => {
    setCartItems((prevItems) => {
      // Prüft, ob GENAU diese Schulform im SELBEN Fachbereich bereits existiert
      const isAlreadyPresent = prevItems.some(
        (i) =>
          i.id === item.id &&
          i.deptId === item.deptId &&
          i.goalId === item.goalId,
      );

      if (isAlreadyPresent) return prevItems;

      return [...prevItems, item];
    });
  };

  const removeFromCart = (itemId) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== itemId));
  };

  const clearCart = () => setCartItems([]);

  return (
    <CartContext.Provider
      value={{ cartItems, addToCart, removeFromCart, clearCart }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
